'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function upperFirst(str) {
    return str.substring(0, 1).toUpperCase() + str.substring(1);
}

exports.upperFirst = upperFirst;
